/**
 * Which lists support row expansion, and which child list renders inside the
 * expansion (PD-15221).
 *
 * The List Configuration modal's "Enable row expansion" toggle only appears
 * for parent listKeys registered here, and enabling it stamps the mapped
 * child listKey into `listOverrides.rowExpansion.listKey`. The child list is
 * a normal list-builder config (own listKey, own saved-search customization),
 * and the hosting module must supply the matching `rowExpansionQuery`
 * callback — see RowExpansionConfiguration in types/list.ts.
 *
 * Registering a new parent here is deliberate: expansion is inert without a
 * module-side data callback, so the toggle should not be offered on lists
 * whose modules don't implement one.
 */
export const ROW_EXPANSION_CHILD_LIST_KEYS: Record<string, string> = {
	quote: 'quote_expansion_lines',
	order: 'order_expansion_lines',
	invoice: 'invoice_expansion_lines',
};

/**
 * The child listKey rendered inside `parentListKey`'s row expansion, or
 * undefined when the parent list doesn't support expansion.
 */
export function getRowExpansionChildListKey(
	parentListKey: string | undefined,
): string | undefined {
	if (parentListKey == null) {
		return undefined;
	}
	return ROW_EXPANSION_CHILD_LIST_KEYS[parentListKey];
}
